import parse from 'html-react-parser';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Bounce, toast } from 'react-toastify';
import { apiConstants } from '../_constants';
import { answerService } from '../_services/answer.service';

import draftToHtml from 'draftjs-to-html';
import { isEnglish } from '../_helpers';
import './exam.css';

export const QnA = ({
  handleNext,
  handlePrev,
  item,
  QnLength,
  mode,
  attempt,
  setQuestions,
  isLoading,
}) => {
  const navigate = useNavigate();
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [selectedAnswer, setSelectedAnswer] = useState(-1);
  const [isAnswerLoading, setIsAnswerLoading] = useState(false);
  useEffect(() => {
    if (item?.answer?.option_index || item?.answer?.option_index == 0) {
      setSelectedAnswer(item?.answer?.option_index);
    } else {
      setSelectedAnswer(-1);
    }
  }, [item]);

  // to convert draft to htm c l
  // const renderText = (text, inlineStyleRanges) => {
  //   return inlineStyleRanges.reduce((acc, styleRange) => {
  //     const style = {};
  //     style[styleRange.style] = true;
  //     return <div style={style}>{acc}</div>;
  //   }, text);
  // };
  // convert draft to text initial call
  // const ContentRenderer = (contentState) => {
  //   const renderedBlocks = contentState?.blocks.map((block) =>
  //     renderText(block.text, block.inlineStyleRanges),
  //   );
  //   return renderedBlocks;
  // };
  // const ContentRenderer = (contentState) => {
  //   const renderedBlocks = contentState?.blocks.map((block, i) => {
  //     const text = block.text;
  //     const parts = text.split(/(\s+)/).map((part, index) => {
  //       const isEnglish = /[a-zA-Z]/.test(part);
  //       return (
  //         <span
  //           dir={isEnglish ? 'ltr' : 'rtl'}
  //           style={{ display: 'inline-block', marginRight: '2px' }}
  //           key={index}
  //         >
  //           {part}
  //         </span>
  //       );
  //     });
  //     return <div key={i}>{parts}</div>;
  //   });
  //   return renderedBlocks;
  // };

  // handle answer --
  const handleAnserSelect = (option, questionId, optionIndex) => {
    setSelectedAnswer(optionIndex);
    setIsAnswerLoading(true);

    let userAnsweredOption = option?.option; // user answered option
    let correctAnswer = Object.keys(item?.answers)[0] == optionIndex;

    let ans = {};
    if (item?.answer) {
      ans = item.answer;
      ans.answer = userAnsweredOption;
      ans.is_correct = correctAnswer;
      ans.option_index = optionIndex;
      ans.updated_at = moment().valueOf();
    } else {
      ans = {
        answer: userAnsweredOption,
        is_correct: correctAnswer,
        attempt: attempt,
        mode: mode,
        order: item.index,
        question_id: questionId,
        option_index: optionIndex,
        topic_id: item.topic_id,
        created_at: moment().valueOf(),
        updated_at: moment().valueOf(),
      };
    }
    answerService.answerAdd(ans).then(
      (res) => {
        setIsAnswerLoading(false);
        item.answer = res.data;
        setQuestions({ ...item, answer: res.data });
      },
      (err) => {
        setIsAnswerLoading(false);
        console.error(err, 'answerAddError');
      },
    );
  };

  // to fetch correct answer from question
  const getCorrectAnswer = (item) => {
    if (item) {
      if (Object.keys(item)[0]) {
        return Object.keys(item)[0];
      } else {
        console.log('inside else condition');
      }
    }
  };
  let correctAnswer = getCorrectAnswer(item?.answers); //to get the correct answer

  return (
    <div className='qna'>
      <div className='d-flex justify-content-end'>
        <div
          className='exitbtn'
          onClick={() => {
            setShowConfirmationModal(true);
          }}
        >
          End Test
        </div>
      </div>
      <div className='questionindex'>
        <div className='questionno mt-4 mb-4'>{`Question ${item.index + 1} / ${QnLength}`}</div>
        <div className='progressbarcontainer'>
          <div
            className='examprogress'
            style={{ width: (100 / QnLength) * (item.index + 1) + '%' }}
          />
        </div>
        {item?.image_question ? (
          <img src={apiConstants.imgUrl + item?.image_question} className='imagequestion' />
        ) : (
          <div
            className={'question ' + (isEnglish(item?.question) ? 'ltrtext' : 'rtltext')}
          >
            {parse(draftToHtml(item?.question), {
              decodeEntities: false,
            })}
          </div>
        )}
        <div className='optionscontainer'>
          {item?.options?.map((opt, index) => {
            const isOptEnglish = isEnglish(opt.option);
            return (
              <div
                className={
                  'optionbox ' +
                  (mode == 1
                    ? selectedAnswer == index
                      ? 'selectedans '
                      : ''
                    : selectedAnswer == index
                    ? selectedAnswer == correctAnswer
                      ? 'correctans '
                      : 'worngans '
                    : correctAnswer == index && selectedAnswer !== -1
                    ? 'correctans '
                    : '') +
                  (isOptEnglish ? 'englishopt' : '')
                }
                key={index}
                onClick={() => {
                  if (mode == 1 || (mode == 2 && selectedAnswer == -1))
                    handleAnserSelect(opt, item._id, index, item.index);
                }}
                // dir='rtl'
              >
                {isOptEnglish && opt?.option}
                {mode == 2 && correctAnswer == index && selectedAnswer !== -1 && (
                  <img
                    src='/img/accept.png'
                    className={'correctansicon ' + (isOptEnglish ? 'englishopticon' : '')}
                  />
                )}
                {mode == 2 && correctAnswer != selectedAnswer && selectedAnswer == index && (
                  <img
                    src='/img/wrong.png'
                    className={'correctansicon ' + (isOptEnglish ? 'englishopticon' : '')}
                  />
                )}
                {!isOptEnglish && opt?.option}
              </div>
            );
          })}

          {item?.answers?.description && selectedAnswer != -1 && mode == 2 && (
            <div
              className={
                'hint d-flex align-items-center gap-2 ' +
                (isEnglish(item?.answers?.description) ? 'ltrtext' : 'rtltext')
              }
            >
              <img src='/img/hinticon.png' className='hinticon' />
              <div
                className='hintdesc'
                style={{ textAlign: isEnglish(item?.answers?.description) ? 'left' : 'right' }}
              >
                {item?.answers?.description}
              </div>
              <img src={apiConstants.imgUrl + item?.answers?.image} className='hintimg' />
            </div>
          )}
        </div>
        <div className='actionscontainer'>
          {/* <div className='skipquestionbtn'>Skip</div> */}
          <div className='actionscontainer gap-2'>
            {(isLoading || isAnswerLoading) && (
              <img src='/img/Loadingicon.gif' className='examloading' />
            )}
            <div
              className={
                'nextprevbtn ' +
                (selectedAnswer == -1 || isLoading || isAnswerLoading ? 'disabled' : '')
              }
              onClick={() => {
                if (selectedAnswer > -1 && !isLoading && !isAnswerLoading) {
                  handleNext(item?.NextId, item?.answer?.order, item?._id);
                } else {
                  toast.error('Select an option to continue', {
                    position: 'bottom-left',
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: 'dark',
                    transition: Bounce,
                  });
                }
                // selectedAnswer > -1 &&
                //   !isLoading &&
                //   !isAnswerLoading &&
                //   handleNext(item?.NextId, item?.answer?.order, item?._id);
              }}
            >
              Next
            </div>
            <div
              className={
                'nextprevbtn prevbtn ' +
                ((item?.index == 0 && item.PrevId == null) || isLoading || isAnswerLoading
                  ? 'disabled'
                  : '')
              }
              onClick={() => {
                if (item?.index > 0 && item.PrevId != null && !isLoading && !isAnswerLoading) {
                  handlePrev(item?.PrevId, item?.index, item?._id);
                } else {
                  toast.error('Select an option to continue', {
                    position: 'bottom-left',
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: 'dark',
                    transition: Bounce,
                  });
                }
              }}
            >
              Prev
            </div>
          </div>
        </div>
      </div>

      {showConfirmationModal && (
        <div className='modal ' style={{ display: 'block', background: ' rgb(10 11 11 / 50%)' }}>
          <div className='modal-dialog' style={{ maxWidth: 650 }}>
            <div className='modal-content'>
              <div className='modal-header justify-content-center' style={{ color: '#0c859d' }}>
                <div className='modal-header-content'>
                  <h4 className='card-title'>Are You Sure?</h4>
                </div>
                <div className='close' style={{ marginTop: -6 }}>
                  <a onClick={() => setShowConfirmationModal(false)}>&times;</a>
                </div>
              </div>
              <div className='modal-body' style={{ textAlign: 'center' }}>
                <div className='modalcontent'>Do you want to exit this Test Mode?</div>
                <div className='d-flex justify-content-center gap-2 mt-4'>
                  <div
                    className='nextprevbtn'
                    onClick={() => {
                      setShowConfirmationModal(false);
                    }}
                  >
                    Close
                  </div>
                  <div className='nextprevbtn' onClick={() => navigate(-1)}>
                    Yes
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
